'use strict';

var tester = require('../util/tester');

var filter = require('./filter');

module.exports = function filterNot(test) {
  test = tester(test);
  return filter(function (data) {
    return !test(data);
  });
};